// eslint-disable-next-line no-unused-vars
import { FormGeneratorConfig } from '../../../utils/formGenerator'
import { FbSliderFormElement } from '../../../utils/formElements'

export const StorageLocationConfig: FormGeneratorConfig = {
    zone: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Number of chars for zone',
            marks: true,
            showValueLabel: 'on',
            key: 'zone_char_slider',
            min: 0,
            max: 4,
        },
    },
    rack: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Number of chars for a rack',
            marks: true,
            showValueLabel: 'on',
            key: 'rack_char_slider',
            min: 0,
            max: 4,
        },
    },
    level: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Number of chars for a level',
            marks: true,
            showValueLabel: 'on',
            key: 'level_char_slider',
            min: 0,
            max: 4,
        },
    },
    position: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Number of chars for a position',
            marks: true,
            showValueLabel: 'on',
            key: 'pos_char_slider',
            min: 0,
            max: 4,
        },
    },
    section: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Number of chars for a section',
            marks: true,
            showValueLabel: 'on',
            key: 'sec_char_slider',
            min: 0,
            max: 4,
        },
    },
}
